<template>
<div class="popup-back">
    <div class="popup-box flex" style="width: 1100px;">
        <img src="" class="book-img"/>
        <div>
            <p></p>
            <div class="cate">
                <p>책 소개</p>
            </div>
            <div class="cate">
                <p>목차</p>
            </div>
            <div class="cate">
                <p>저자 소개</p>
            </div>
        </div>
    </div>
</div>    
</template>
<script>
export default {
    name: 'Detail',
    created() {

    }
}
</script>
<style>
@import url(./assets/css/popup.css);

.book-img {
    width: 500px;
}
.cate {

}
.cate p {
    font-weight: 600;
    text-align: left;
    font-size: 17px;
}
.flex {
    display: flex;
}
</style>
